import React, { useState, useEffect, useRef } from "react";
import "./App.css";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "./components/Card";
import Ball from "./components/Ball";
import shot from "./sounds/shot.mp3";
import winSound from "./sounds/win-sound.aac";
import loosSound from "./sounds/loos-sound.aac";
import logo from "./images/logo.png";
import startButton from "./images/restart-button.png";
import frontFace from "./images/front-card-face.png";
import backFace from "./images/back-card-face.png";
import sadFace from "./images/sad-face.png";
import cup from "./images/cup.png";
import p1 from "./images/p1.jpg";
import p2 from "./images/p2.jpg";
import p3 from "./images/p3.jpg";
import p4 from "./images/p4.jpg";
import p5 from "./images/p5.jpg";
import p6 from "./images/p6.jpg";
import p7 from "./images/p7.jpg";
import p8 from "./images/p8.jpg";
import p9 from "./images/p9.jpg";
import p10 from "./images/p10.jpg";
import p11 from "./images/p11.jpg";
import p12 from "./images/p12.jpg";
import Confetti from "react-confetti";
import pointer from "./images/pointer.png";

function App() {
  const [products, setProducts] = useState([
    { id: 1, title: "1", image: p1 },
    { id: 2, title: "2", image: p2 },
    { id: 3, title: "3", image: p3 },
    { id: 4, title: "4", image: p4 },
    { id: 5, title: "5", image: p5 },
    { id: 6, title: "6", image: p6 },
    { id: 7, title: "7", image: p7 },
    { id: 8, title: "8", image: p8 },
    { id: 9, title: "9", image: p9 },
    { id: 10, title: "10", image: p10 },
    { id: 11, title: "11", image: p11 },
    { id: 12, title: "12", image: p12 },
  ]);

  const [positions, setpositions] = useState([
    { score: 2, x: 280, y: 250, size: 280 },
    { score: 2, x: 380, y: 550, size: 280 },
    { score: 2, x: 680, y: 150, size: 280 },
    { score: 2, x: 1020, y: 580, size: 280 },
    { score: 2, x: 1070, y: 80, size: 280 },
    { score: 2, x: 25, y: 600, size: 280 },

    { score: 4, x: 500, y: 100, size: 140 },
    { score: 4, x: 810, y: 500, size: 140 },
    { score: 4, x: 1270, y: 410, size: 140 },
    { score: 4, x: 160, y: 150, size: 140 },
    { score: 4, x: 25, y: 360, size: 140 },
    { score: 4, x: 1280, y: 840, size: 140 },
    { score: 4, x: 25, y: 360, size: 140 },

    { score: 6, x: 30, y: 30, size: 80 },
    { score: 6, x: 630, y: 460, size: 80 },
    { score: 6, x: 940, y: 80, size: 80 },
    { score: 6, x: 770, y: 790, size: 80 },
    { score: 6, x: 1070, y: 460, size: 80 },
    { score: 6, x: 1340, y: 40, size: 80 },
    { score: 6, x: 320, y: 890, size: 80 },
  ]);

  const [gameStatus, setGameStatus] = useState("idle");
  const [totalChance, setTotalChance] = useState(4);
  const [totalScore, setTotalScore] = useState(0);
  const [win, setWin] = useState(false);
  const [giftSelected, setGiftSelected] = useState(false);
  const [giftList, setGiftList] = useState([]);
  const [pointerPosition, setPointerPosition] = useState([0, 0]);
  const [pointerShow, setPointerShow] = useState(false);
  const [targetShot, setTargetShot] = useState(false);

  const resultBox = useRef();
  const gameBox = useRef();

  function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  useEffect(() => {
    // gameBox.current.classList.add("scale-in-center");
  }, []);

  const onGiftFrontClicked = (index, id) => {
    if (giftSelected) return;
    let c = JSON.parse(JSON.stringify(giftList));
    let i = 0;
    c.forEach((element) => {
      if (element.id === id && i === index) {
        element.flipped = true;
        let gifts = getCookie("gifts");
        gifts = gifts.split(",");
        let text = "";
        gifts.forEach((element1) => {
          let sp = element1.split("=");
          if (Number(sp[0]) === Number(element.id)) {
            sp[1] = Number(sp[1]) + 1;
            element1 = sp[0] + "=" + sp[1];
          }
          if (text === "") text = element1;
          else text += "," + element1;
        });

        setCookie("gifts", text, 365);
      }
      i++;
    });
    setGiftList(c);
    setGiftSelected(true);
    var audio = new Audio(winSound);
    audio.play();
  };

  const userWin = () => {
    let gifts = getCookie("gifts");
    let final = [];

    if (!gifts) {
      let text = "";
      products.forEach((element) => {
        final.push(element);
        if (text === "") text = element.id + "=0";
        else text += "," + element.id + "=0";
      });
      setCookie("gifts", text, 365);
    } else {
      gifts = gifts.split(",");
      let g = [];
      gifts.forEach((element) => {
        let sp = element.split("=");
        if (Number(sp[1]) < 2) {
          products.forEach((element1) => {
            if (Number(element1.id) === Number(sp[0])) g.push(element1);
          });
        }
      });

      if (g.length > 0) {
        while (final.length < 12) {
          g.forEach((element) => {
            if (final.length < 12) final.push(element);
          });
        }
      } else {
        let text = "";
        products.forEach((element) => {
          final.push(element);
          if (text === "") text = element.id + "=0";
          else text += "," + element.id + "=0";
        });
        setCookie("gifts", text, 365);
      }
    }

    let suffle = shuffle(final);
    setGiftList(suffle);
    setWin(true);

    var audio = new Audio(winSound);
    audio.play();
    setTimeout(() => {
      setGameStatus("result");
      resultBox.current.classList.remove("slide-out-elliptic-top-bck");
      resultBox.current.classList.add("slide-in-elliptic-bottom-fwd");
      gameBox.current.classList.remove("scale-in-center");
      gameBox.current.classList.add("slide-out-bck-center");
    }, 1000);
  };

  function shuffle(array) {
    var m = array.length,
      t,
      i;
    while (m) {
      i = Math.floor(Math.random() * m--);
      t = array[m];
      array[m] = array[i];
      array[i] = t;
    }
    return array;
  }

  const onRestartGame = () => {
    let c = JSON.parse(JSON.stringify(giftList));

    c.forEach((element) => {
      element.flipped = false;
    });
    setGiftList(c);

    resultBox.current.classList.remove("slide-in-elliptic-bottom-fwd");
    resultBox.current.classList.add("slide-out-elliptic-top-bck");
    gameBox.current.classList.remove("slide-out-bck-center");
    gameBox.current.classList.add("scale-in-center");

    setTotalScore(0);
    setTotalChance(4);

    setTimeout(() => {
      setGameStatus("idle");
      setGiftSelected(false);
    }, 700);
  };

  const onShot = (x, y, score) => {
    if (pointerShow) return;
    var audio = new Audio(shot);
    audio.play();
    setPointerPosition([x - 40, y - 40]);
    let ts = totalScore + score;
    let tc = totalChance - 1;
    setTotalScore(ts);
    setTotalChance(tc);
    setTargetShot(true);
    setPointerShow(true);
    setTimeout(() => {
      setTargetShot(false);
      setPointerShow(false);
      if (tc === 0) {
        if (ts < 10) {
          setWin(false);
          setGameStatus("result");
          resultBox.current.classList.remove("slide-out-elliptic-top-bck");
          resultBox.current.classList.add("slide-in-elliptic-bottom-fwd");
          gameBox.current.classList.remove("scale-in-center");
          gameBox.current.classList.add("slide-out-bck-center");
          var audio = new Audio(loosSound);
          audio.play();
        } else {
          userWin();
        }
      }
    }, 3000);
  };

  const mainClick = (e) => {
    if (pointerShow) return;
    var audio = new Audio(shot);
    audio.play();
    setPointerPosition([e.clientX - 40, e.clientY - 40]);
    let tc = totalChance - 1;
    setTotalChance(tc);
    setPointerShow(true);
    setTimeout(() => {
      setPointerShow(false);
      if (tc === 0) {
        if (totalScore < 10) {
          userLoos();
        } else {
          userWin();
        }
      }
    }, 3000);
  };

  const mainTouch = (e) => {
    if (pointerShow) return;
    var audio = new Audio(shot);
    audio.play();
    setPointerPosition([e.touches[0].clientX - 40, e.touches[0].clientY - 40]);
    let tc = totalChance - 1;
    setTotalChance(tc);
    setPointerShow(true);
    setTimeout(() => {
      setPointerShow(false);
      if (tc === 0) {
        if (totalScore < 10) {
          userLoos();
        } else {
          userWin();
        }
      }
    }, 3000);
  };

  const userLoos = () => {
    setWin(false);
    setGameStatus("result");
    resultBox.current.classList.remove("slide-out-elliptic-top-bck");
    resultBox.current.classList.add("slide-in-elliptic-bottom-fwd");
    gameBox.current.classList.remove("scale-in-center");
    gameBox.current.classList.add("slide-out-bck-center");
    var audio = new Audio(loosSound);
    audio.play();
  };

  return (
    <Box sx={{ position: "relative", height: "100vh" }}>
      <Grid
        container
        spacing={2}
        sx={{
          // margin: "15px",
          // flex: "1",
          height: "calc(100vh - 30px)",
          justifyContent: "stretch",
          alignItems: "stretch",
          position: "absolute",
          left: "0px",
          top: "15px",
        }}
        ref={gameBox}
      >
        <Box
          style={{
            width: "100vw",
            height: "100vh",
            position: "absolute",
            left: "0px",
            top: "-15px",
            // backgroundColor: "green",
          }}
          onTouchStart={mainTouch}
          onClick={mainClick}
        />
        <Grid item xs={9.3} className="ballsContainer">
          <Box
            style={{
              width: "100vw",
              height: "100%",
              position: "absolute",
              left: "0px",
              top: "0px",
              // backgroundColor: "blue",
            }}
            onTouchStart={mainTouch}
            onClick={mainClick}
          />
          {positions.map((item, i) => {
            return (
              <Ball
                key={i}
                index={i}
                info={item}
                onShot={onShot}
                stop={pointerShow}
              />
            );
          })}
        </Grid>
        <Grid
          item
          xs={2.7}
          sx={{
            display: "flex",
            flexDirection: "column",
            padding: "0px",
            justifyContent: "center",
            alignItems: "stretch",
          }}
        >
          <Box
            sx={{
              // width: "100%",
              display: "flex",
              flexDirection: "column",
              border: "8px solid white",
              borderRadius: "20px",
              backgroundColor: "rgba(0, 0, 0, 0.6)",
              alignItems: "stretch",
              margin: "16px",
            }}
          >
            <div
              style={{
                marginTop: "-90px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={logo}
                alt=""
                style={{
                  width: "80%",
                  objectFit: "contain",
                }}
              />
            </div>
            <Box
              sx={{
                margin: "20px 10px",
                color: "white",
                fontSize: "40px",
                fontFamily: "BYekan",
                fontWeight: "bold",
                textAlign: "center",
              }}
            >
              تعداد پرتاب
            </Box>
            <Box
              sx={{
                border: "8px solid white",
                minHeight: "100px",
                borderRadius: "20px",
                backgroundColor: "rgba(0, 0, 0, 0.6)",
                textAlign: "center",
                fontSize: "40px",
                fontFamily: "Pixel",
                color: "#FF5252",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "10px 50px",
                marginBottom: "15px",
                margin: "0px 15px 15px 15px",
              }}
            >
              {totalChance}
            </Box>

            <Box
              sx={{
                margin: "20px 10px",
                color: "white",
                fontSize: "40px",
                fontFamily: "BYekan",
                fontWeight: "bold",
                textAlign: "center",
              }}
            >
              امتیاز
            </Box>
            <Box
              sx={{
                border: "8px solid white",
                minHeight: "100px",
                borderRadius: "20px",
                backgroundColor: "rgba(0, 0, 0, 0.6)",
                textAlign: "center",
                fontSize: "40px",
                fontFamily: "Pixel",
                color: "#FF5252",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "10px 50px",
                marginBottom: "15px",
                margin: "0px 15px 15px 15px",
              }}
            >
              {totalScore}
            </Box>

            {/* {gameStatus === "idle" && (
              <Box sx={{ width: "100%" }}>
                <img
                  className="vibrate-1"
                  src={startButton}
                  alt=""
                  style={{
                    width: "100%",
                    objectFit: "contain",
                    marginBottom: "-35px",
                    cursor: "pointer",
                  }}
                  onClick={onStartGame}
                />
              </Box>
            )} */}
          </Box>
        </Grid>
        {/* <Grid item xs={0.3} /> */}
      </Grid>

      <Box
        sx={{
          width: "100vw",
          height: "100vh",
          justifyContent: "center",
          alignItems: "center",
          position: "absolute",
          left: "0",
          top: "0",
          display: "flex",
          visibility: gameStatus === "result" ? "visible" : "hidden",
        }}
      >
        {gameStatus === "result" && win && <Confetti />}
        <Box ref={resultBox} className="resultBox">
          <img
            src={logo}
            alt=""
            style={{
              width: "240px",
              objectFit: "contain",
              marginTop: "-90px",
            }}
          />
          <Box
            sx={{
              display: "flex",
              flexDirection: win ? "row" : "column",
              justifyContent: win ? "space-between" : "center",
              alignItems: "center",
              width: "80%",
            }}
          >
            <img
              src={win ? cup : sadFace}
              alt=""
              style={{
                width: win ? "120px" : "35%",
                objectFit: "contain",
                marginTop: win ? "30px" : "60px",
                marginBottom: win ? "30px" : "0px",
              }}
            />

            <Box
              sx={{
                margin: win ? "20px 0px" : "40px 0px",
                color: "white",
                fontSize: "30px",
                fontFamily: "BYekan",
                // fontWeight: "bold",
                // maxWidth: "700px",
                whiteSpace: "wrap",
                textAlign: "center",
              }}
            >
              {!win ? "شانس باهات یار نبود" : "تبریک، برنده شدی"}
              {win && <br />}
              {win ? "یکی از کارت‌های زیر رو انتخاب کن" : ""}
            </Box>
            {win && (
              <img
                src={cup}
                alt=""
                style={{
                  width: "120px",
                  objectFit: "contain",
                  margin: "30px 0px",
                }}
              />
            )}
          </Box>

          {win && (
            <Box className="grid" style={{ width: "45vw", margin: "0px" }}>
              {giftList.map((item, i) => {
                return (
                  <Card
                    key={i}
                    index={i}
                    onFrontClicked={onGiftFrontClicked}
                    info={item}
                    flipped={item.flipped}
                    frontFace={frontFace}
                    backFace={backFace}
                  />
                );
              })}
            </Box>
          )}

          {(!win || (win && giftSelected)) && (
            <Box sx={{ width: "50%" }}>
              <img
                className="vibrate-1"
                src={startButton}
                alt=""
                style={{
                  width: "100%",
                  objectFit: "contain",
                  marginTop: !win ? "0px" : "30px",
                  marginBottom: !win ? "-30px" : "-40px",
                  cursor: "pointer",
                }}
                onClick={onRestartGame}
              />
            </Box>
          )}
        </Box>
      </Box>
      {pointerShow && (
        <img
          src={pointer}
          alt=""
          className="pulsate-fwd"
          style={{
            position: "absolute",
            left: pointerPosition[0],
            top: pointerPosition[1],
            width: "80px",
            height: "80px",
          }}
        />
      )}
      {pointerShow && targetShot && (
        <Confetti
          confettiSource={{
            x: pointerPosition[0] + 40,
            y: pointerPosition[1] + 40,
            w: 2,
            h: 2,
          }}
          recycle={false}
          gravity={0.4}
        />
      )}
    </Box>
  );
}

export default App;
